export default {
      id: "contacts_partner-usage",
      viewBox: "0 0 48 36",
      url: __webpack_public_path__ + "sprite.svg#contacts_partner",
      toString: function () {
        return this.url;
      }
    }